import { render } from "./ParcoursSpirituelsPage.vue?vue&type=template&id=042b87ae"
import script from "./ParcoursSpirituelsPage.vue?vue&type=script&lang=js"
export * from "./ParcoursSpirituelsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__